import { render } from "./DonutsDashboard.vue?vue&type=template&id=08fddb54"
import script from "./DonutsDashboard.vue?vue&type=script&lang=js"
export * from "./DonutsDashboard.vue?vue&type=script&lang=js"
script.render = render

export default script